import { createSlice } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';
import {
  PromoCodeApi,
  PromoCodeApi_extrareducer,
} from './promo-code/promoCodeApi';

const initialState = {
  promoCodeApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  promoCode: '',
};

export const PromoCodeSlice = createSlice({
  name: 'promoCode',
  initialState,
  reducers: {
    updatePromoCode: (state, action) => {
      state.promoCode = action.payload;
    },
  },
  extraReducers: {
    ...PromoCodeApi_extrareducer,
  },
});

export function usePromoCodeStore() {
  const promoCodeApiState = useSelector(
    (state) => state.promoCode.promoCodeApiState
  );
  const promoCode = useSelector((state) => state.promoCode.promoCode);
  const dispatch = useDispatch();
  return {
    promoCodeApiState,
    promoCode,
    PromoCodeApi: (payload) => dispatch(PromoCodeApi(payload)),
    updatePromoCode: (payload) => dispatch(updatePromoCode(payload)),
  };
}

export const { updatePromoCode } = PromoCodeSlice.actions;

export default PromoCodeSlice.reducer;
